import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@repo/shared-styles";
import {cssUrl, staticUrl} from "@repo/urls";

import LoveToLearnBullet from "./love-to-learn-bullet.tsx";

type Props = {
    sectionHeader: string;
};

export default class LoveToLearn extends React.Component<Props> {
    render(): React.ReactNode {
        const {sectionHeader} = this.props;

        return (
            <View style={styles.background}>
                <View style={styles.foreground}>
                    <View style={[styles.layoutColumn, styles.imageColumn]}>
                        <img
                            src={staticUrl(
                                "/images/kids/love-to-learn-characters.svg",
                            )}
                            alt={t`Khan Kids Characters Celebrating`}
                            className={css(styles.mainImage)}
                        />
                    </View>

                    <View style={styles.layoutColumn}>
                        <h2 className={css(styles.header)}>{sectionHeader}</h2>

                        <View style={styles.bulletedListContainer}>
                            <LoveToLearnBullet
                                header={t`Whimsical characters`}
                                text={t`Learning stays fun as five whimsical characters guide kids through activities and stories.`}
                                imgAltText={t`Reya Red Panda`}
                                imgPath="/images/kids/reya-icon.svg"
                                imgHeight={34}
                            />

                            <LoveToLearnBullet
                                header={t`Original content`}
                                text={t`Original interactive activities, books, animated videos, and creative lessons captivate children’s attention.`}
                                imgAltText={t`Book`}
                                imgPath="/images/kids/book-icon.svg"
                                imgHeight={46}
                            />

                            <LoveToLearnBullet
                                header={t`Diverse learning methods`}
                                text={t`Young learners engage with topics through open-ended creative tasks as well as assessed activities.`}
                                imgAltText={t`Crayon`}
                                imgPath="/images/kids/crayon-icon.svg"
                                imgHeight={44}
                            />

                            <LoveToLearnBullet
                                header={t`Fun rewards`}
                                text={t`As kids learn they collect accessories like bugs, hats, and toys for their favorite characters in the app.`}
                                imgAltText={t`Airplane`}
                                imgPath="/images/kids/reward.svg"
                                imgHeight={42}
                            />
                        </View>
                    </View>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    background: {
        justifyContent: "center",

        backgroundImage: cssUrl("/images/kids/love-to-learn-bg.svg"),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    },

    foreground: {
        maxWidth: 1024,
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 15px",
        flexDirection: "row",
        alignSelf: "center",

        [mediaQueries.md]: {
            padding: "0px 10px",
        },
    },

    layoutColumn: {
        flex: "0 0 auto",
        boxSizing: "border-box",

        [mediaQueries.smOrSmaller]: {
            width: "100%",
            height: "auto",
        },
    },

    imageColumn: {
        [mediaQueries.mdOrSmaller]: {
            display: "none",
        },
    },

    mainImage: {
        maxWidth: 498,
        marginRight: 120,
        marginTop: 20,
    },

    bulletedListContainer: {
        maxWidth: 425,
        marginBottom: 80,
        paddingTop: 45,

        [mediaQueries.smOrSmaller]: {
            paddingTop: 80,
            marginBottom: 0,
        },
    },

    header: {
        fontSize: 48,
        lineHeight: 1.19,
        fontWeight: "bold",
        marginTop: 100,
        marginBottom: 0,

        [mediaQueries.md]: {
            fontSize: 46,
            lineHeight: 1.24,
        },

        [mediaQueries.mdOrSmaller]: {
            textAlign: "center",
        },

        [mediaQueries.smOrSmaller]: {
            fontSize: 24,
            lineHeight: 2.38,
            marginTop: 50,
        },
    },
});
